module.exports = __webpack_public_path__ + "static/img/card_3_13.d66f96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_3_13.png
// module id = VZiR
// module chunks = 0